import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-width": ".5",
      d: "M1.192 20.873c.168.092 4.181 2.253 8.64 2.253 4.83 0 8.5-2.168 8.653-2.26a.37.37 0 0 0 .179-.316c0-2.971-.911-5.69-2.565-7.656-1.158-1.376-2.61-2.313-4.211-2.745a4.784 4.784 0 1 0-4.112 0c-1.601.432-3.053 1.37-4.21 2.745C1.91 14.86 1 17.579 1 20.55c0 .135.074.259.192.323ZM5.784 5.83a4.048 4.048 0 1 1 8.096 0 4.048 4.048 0 0 1-8.096 0Zm-1.655 7.538c1.494-1.776 3.52-2.754 5.703-2.754s4.209.978 5.703 2.754c1.504 1.786 2.349 4.254 2.391 6.967-.787.427-4.06 2.055-8.094 2.055-3.731 0-7.245-1.638-8.094-2.063.044-2.71.889-5.175 2.39-6.96Z"
    }, null, -1)
  ])))
}
export default { render: render }